import ClientUtils from '../utils/http-clients';
import Settings from '../resources/settings';

const baseUrl = Settings.API_BASE_PATH + '/partnerConfig/partners';

export const getSystemConfigurations = (partnerBid, config) => {
  const url = `${baseUrl}/${partnerBid}/systemConfigurations/cache?key=additional.operational.report.access&key=importProfile.matchOnId&key=restricted.operational.report.access`;

  return ClientUtils.makeGetRequest(url, config);
};

export const getTermsForPartnerURI = (partnerBid) => `${baseUrl}/${partnerBid}/terms`;

//Retrieve specific keys from the configuration cache
export default {
  getSystemConfigurations,
};
